module.exports = __webpack_public_path__ + "media/img/event/speakers/Danelle-Lee-717cb450feae3db68040489449940863.jpg";